module.exports = __webpack_public_path__ + "static/img/Z69.d6d04731.png";